const Manufacturers = () => import("Core/companies/manufacturers/views/Manufacturers");
const ManufacturersForm = () => import("Core/companies/manufacturers/views/ManufacturersForm");
const ManufacturersProfile = () => import("Core/companies/manufacturers/views/ManufacturerProfile");

export default {
    children: [
        {
            path: "configuration/manufacturers",
            name: "manufacturers",
            component: Manufacturers,
            meta: {
                requiresAuth: true,
                title: "lang.manufacturers",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/manufacturer/:id?",
            name: "manufacturer",
            component: ManufacturersProfile,
            meta: {
                requiresAuth: true,
                title: "lang.manufacturers",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
